import { render, staticRenderFns } from "./IconVimeo.vue?vue&type=template&id=6a5f2047&"
import script from "./IconVimeo.vue?vue&type=script&lang=js&"
export * from "./IconVimeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports